import { Component, Input } from '@angular/core';
import { ModalService } from '../../../core/modal/modal.service';
import { Tariff } from '../tariff.model';

@Component({
  selector: 'tax-tariff-description-modal',
  templateUrl: 'tariff-description-modal.component.html',
  styleUrls: ['tariff-description-modal.component.sass'],
})

export class TariffDescriptionModalComponent {
  @Input() tariff?: Tariff;

  constructor(
    private modalService: ModalService,
  ) {
  }

  closeModal(): void {
    this.modalService.close();
  }
}
